import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Type declarations are used at compile-time as 'headers' only (does NOT include the files)

import { ImageIdentifierLibrary } from "abweb/service/image/api/ImageIdentifierLibrary";
/**
 * This implementation of IImageIdentifierService is intended to cover the simple case where a fixed set of
 * image identifiers can be established. At construction time, it is populated with a fixed set of
 * image identifiers.
 */
export class SimpleImageIdentifierService {
  constructor(...registries) {
    _defineProperty(this, "_library", new ImageIdentifierLibrary());
    this.doMerge(registries);
  }
  mergeRegistries(...registries) {
    this.doMerge(registries);
  }
  doMerge(registries) {
    if (registries !== null) {
      registries.forEach(registry => {
        this.addImageIdentifierInfos(registry.getImageIdentifierInfos());
      });
    }
  }
  addImageIdentifierInfos(images) {
    if (images !== null) {
      images.forEach(info => {
        this.addImageIdentifierInfo(info);
      });
    }
  }
  addImageIdentifierInfo(info) {
    this._library.addImageIdentifierInfo(info);
  }
  getAllIdentifiers() {
    return this._library.getAllIdentifiers();
  }

  /**
   * Loads image info from identifier library and returns the identifier. Throws an error if there is no identifier
   * present.
   * @param identifier
   * @returns {ImageIdentifierInfo}
   */
  getIdentifierInfo(identifier) {
    const info = this.findIdentifierInfo(identifier);
    if (info === null) {
      throw new Error("Invalid image identifier:" + identifier);
    }
    return info;
  }

  /**
   *
   * Looks for and returns identifier info. Returns null if none found.
   *
   * @param identifier
   * @returns {ImageIdentifierInfo}
   */
  findIdentifierInfo(identifier) {
    return this._library.findImageIdentifierInfoByIdentifier(identifier);
  }
  isVirtualIdentifierInfoSource() {
    return false;
  }
  loadImageInfoCustomizations() {
    return new Promise(() => 0);
  }
}
//# sourceMappingURL=SimpleImageIdentifierService.js.map
